import Layout from '@/layout'

const hospitalManage = {
    path: '/hospital',
    component: Layout,
    children: [
        // 医院列表
        {
            path: '/hospital/hospitalList',
            name: 'hospitalList',
            component: () => import('@/views/doctor/hospital/hospitalList'),
            meta: { activeMenu: '/hospital/hospitalList' }
        },
        // 医院详情
        {
            path: '/hospital/hospitalList/detail',
            name: 'hospitalDetail',
            component: () => import('@/views/doctor/hospital/hospitalDetail'),
            meta: { activeMenu: '/hospital/hospitalList' }
        },
        // 医院新增
        {
            path: '/hospital/hospitalList/add',
            name: 'hospitalAdd',
            component: () => import('@/views/doctor/hospital/hospitalAdd'),
            meta: { activeMenu: '/hospital/hospitalList', title: '新增医院' }
        },
        // 医生集团列表
        {
            path: '/hospital/hospitalGroupList',
            name: 'hospitalGroupList',
            component: () => import('@/views/doctor/hospital/hospitalGroupList'),
            meta: { activeMenu: '/hospital/hospitalGroupList' }
        },
        // 科室列表
        {
            path: '/hospital/deptList',
            name: 'deptList',
            component: () => import('@/views/doctor/hospital/deptList'),
            meta: { activeMenu: '/hospital/deptList' }
        },
        // 科室详情
        {
            path: '/hospital/deptList/deptDetail/:hospitalId/:deptId',
            name: 'deptDetail',
            component: () => import('@/views/doctor/hospital/deptDetail'),
            meta: { activeMenu: '/hospital/deptList' }
        }
    ]
}

export default hospitalManage
